// copied from https://github.com/YasudaYutaka/uuid-utils/blob/main/src/utils/uuidUtils.js
// which was published under MIT license

export const validateUUID = (uuid) => {
  const pattern = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/
  return pattern.test(uuid)
}

export const validateUUIDWithoutHyphen = (uuid) => {
  const pattern = /^[0-9a-fA-F]{32}$/
  return pattern.test(uuid)
}

export const addHyphen = (uuid) =>
  validateUUID(uuid)
    ? uuid
    : validateUUIDWithoutHyphen(uuid)
      ? `${uuid.slice(0, 8)}-${uuid.slice(8, 12)}-${uuid.slice(12, 16)}-${uuid.slice(16, 20)}-${uuid.slice(20)}`
      : "Invalid UUID without hyphen"
